import * as React from 'react';

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { styled } from '@mui/material/styles';

import Link from '@mui/material/Link';

import { useTheme } from '@mui/material/styles';

import {INSTRUCTORS, LEVEL, CREDITPOINTS, LANGUAGES, STUDY_AREAS, ENGLISH, GERMAN, CP, ATTRIBUTES} from './Data'

import { GB, DE } from 'country-flag-icons/react/3x2'


const NoMaxWidthTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 'none',
	},
});

function TooltipTableRow({title, data}) {
	return (
		<TableRow>
			<TableCell component="th" scope="row" style={{ verticalAlign: 'top' }}>
				<Typography color="white"  variant="body2"><b>{title}</b>&nbsp;&nbsp;</Typography>
			</TableCell>
			<TableCell>
				<Typography color="white" variant="body2">{data}</Typography>
			</TableCell>
            </TableRow>
	);
	
}

export default function Course({ cell, showDetails }) {
	
	const [tooltipIsOpen, setTooltipIsOpen] = React.useState(false);
	
	const theme = useTheme();

	// define GUI elements
	return (
		<React.Fragment>
			<NoMaxWidthTooltip 
			open={tooltipIsOpen}
			onOpen={() => setTooltipIsOpen(true)}
			onClose={() => setTooltipIsOpen(false)}
			arrow title={
				<React.Fragment>
					<TableContainer>
						<Table size="small">
							<TableBody>
								<TooltipTableRow title={INSTRUCTORS[theme.language]} data = {cell.instructors.join(", ")} />
								<TooltipTableRow title={LEVEL[theme.language]} data = {cell.level} />
								<TooltipTableRow title={CREDITPOINTS[theme.language]} data ={cell.creditPoints + " " + CP[theme.language]}  />
								<TooltipTableRow title={LANGUAGES[theme.language]} data = {
									cell.languages.map((l, index) => 
									<React.Fragment>
									{(l === GERMAN[theme.language] ? 
										<DE title="Deutsch" style={{width: '1em'}}/> :
										l === ENGLISH[theme.language] ?
											<GB title="English" style={{width: '1em'}}/> : l)}
									&nbsp;
									{l}
									{(index + 1) < cell.languages.length ? ", " : ""}
		
									</React.Fragment>
									)}
								/>
								<TooltipTableRow title={
									<React.Fragment>
										{STUDY_AREAS[theme.language]}<br/>
										[{ATTRIBUTES[theme.language]} (&#129513;)]
									</React.Fragment>} 
									data = {cell.studyAreas.map((sa) =>(<div>
										<Typography color="white" variant="body2"><b>{sa.studyProgram}</b> - <i>{sa.studyArea}</i> {sa.attributes.length > 0 ? '[' + sa.attributes.join(', ') + '] ' : ' '}
										{/*<Link href={sa.handbookUrl} target="_blank" underline="hover">
											{"\uD83D\uDCD6"}
										</Link>*/}
										</Typography>
									</div>)) 
								} />
							</TableBody>
						</Table>
					</TableContainer>
				</React.Fragment>
			}>
				<div onClick={() => setTooltipIsOpen(true)}>
					<Typography variant="body2">
						<b>{cell.name}</b> -
						<i>{cell.instructors.join(", ")}</i>
						{ showDetails ?
							<Typography variant="body2" component="span"> [
							{cell.level}&nbsp;| {cell.creditPoints}&nbsp;{CP[theme.language]}&nbsp;
							| {cell.languages.map((l, index) => 
								<React.Fragment>
								{(l === GERMAN[theme.language] ? 
									<DE title="Deutsch" style={{width: '1em'}}/> :
									l === ENGLISH[theme.language] ?
										<GB title="English" style={{width: '1em'}}/> : l)}
										
								{(index + 1) < cell.languages.length ? ", " : ""}
	
								</React.Fragment>
							)}
							{cell.studyAreas.flatMap((sa) => sa.attributes).length > 0 ? <Typography variant="body2" component="span">&nbsp;| &#129513;:&nbsp;{[...new Set(cell.studyAreas.flatMap((sa) => sa.attributes))].sort().join(", ")}</Typography> : <Typography component="span" />}
							]</Typography>
							: ""
						}
					</Typography>
				</div>
			</NoMaxWidthTooltip>

		</React.Fragment>
	);
}